import { pushEcommerceEvent } from '@app/infrastructure/gtm/pushEcommerceEvent';
import { GtmEventName } from '@app/domain/model/gtm/GtmEventName';
import { EcommerceItem } from '@app/domain/model/gtm/EcommerceItem';
import { GtmItemCategory } from '@app/domain/model/gtm/GtmItemCategory';
import { HomeInsuranceRiskPackage } from '@app/domain/model/eshop/home/HomeInsuranceRiskPackage';
import { ProductDataRider } from '@app/domain/model/eshop/transport/ProductDataRider';

export function trackAddToCart(
    selectedRisk: Nullable<HomeInsuranceRiskPackage>,
    selectedRiders: ProductDataRider[],
): void {
    const items: EcommerceItem[] = [];

    if (selectedRisk) {
        const riskPrice = selectedRisk.premiumAfterDiscount ?? selectedRisk.premium ?? 0;

        if (riskPrice > 0) {
            items.push({
                item_name: selectedRisk.name,
                item_id: selectedRisk.code,
                price: riskPrice,
                item_category: GtmItemCategory.HomeInsurance,
                quantity: 1,
            });
        }
    }

    selectedRiders.forEach(rider => {
        if (rider.riderGuid && rider.premiums.premium > 0) {
            items.push({
                item_name: rider.riderName,
                item_id: rider.typeCode ?? '',
                price: rider.premiums.premium,
                item_category: GtmItemCategory.Rider,
                quantity: 1,
            });
        }
    });

    if (items.length === 0) {
        return;
    }

    const totalValue = items.reduce((sum, item) => sum + item.price, 0);

    pushEcommerceEvent(GtmEventName.AddToCart, {
        currency: 'EUR',
        value: totalValue,
        items,
    });
}
